module.exports = __webpack_public_path__ + "static/BODEGA-bc37dfde457092c74322a0a4a121022b.jpg";